import axios from 'axios';
import { setHeaders } from '@/shared/services/headers';
import { AUTH_TOKEN } from '@/shared/constants/cookies-const';
export default {
    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.cncode ? this.$siteSettings.data.cncode : "91",
                mobileNo: "",
                userId: "",
                password: "",
                type: 1,
                captchaText: '',
                referCode: "",
                otp: "",
                userName: ""
            },
            isOtpApiCalled: false,
            otpSent: false, // Added variable to track OTP sent status
            isDisabled: true,
            resendOtp: false,
            timerRunning: false,
            minutes: 5,
            seconds: 0,
            passwordFieldType: 'password',
            confPasswordFieldType: 'password',
            init: false,

            showValidationError: false,
            loading: false,
            demoLoading: false,
            showErrorMobile: false,
            passwordValidation: false,
            loadingUpdate: false,
            loginErrorRes: null,
            otpSuccessRes: null,
            otpErrorRes: null,
            signUpErrorRes: null,
            forgotPassErrorRes: null,
            initValues : [
                { value: 1000 },
                { value: 2000 },
                { value: 3000 },
                { value: 4000 }
            ]
        }
    },
    methods: {
        setUserIdsToStore(userId) {
            let oldUserIds = this.$store.getters?.logInData?.userIds || [];
            if(this.form.type === 2) {
                if(this.$auth?.user?.last_login_at){
                    oldUserIds.push(userId);
                }
                let data = {
                    logInWithMobile: false,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
            else {
                let data = {
                    logInWithMobile: true,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
        },
        signInMethodCall(loginMethod) {
            if (!this.loading) {
                let id = this.getId();
                if (!this.$helper.notNull(id) || !this.$helper.notNull(this.form.password)) {
                    this.$errorToast(this.$t('please-fill-all-the-fields', 'Please fill all the fields.'))
                } else {
                    this.loginMethod == 'password' ? this.loginServiceCall('LOGIN_API', 'nondemo') : this.signInwithOtp();
                }
            }
        },
        demoUserLogin() {
            this.form.type = 1;
            this.form.userId = "demouser";
            this.form.password = "demopass";
            this.loginServiceCall('DEMO_LOGIN_API', 'demo')
        },
        async loginServiceCall(url, type, page = null) {
            this.$store.dispatch('setGlobalLoader', true);
            let id = this.getId();
            if (type == 'demo') {
                this.demoLoading = true;
            } else {
                this.loading = true;
            }
            let data = {
                "userid": id.toString(),
                "type": this.form.type == 2 ? 'userid' : 'phone',
                "password": this.form.password,
                "countryCode": this.form.code,
            };

            await this.$apiCall('post', url, type!='demo' ? data : null).then(response => {
                if (type == 'demo') {
                    this.demoLoading = false;
                } else {
                    this.loading = false;
                }
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response.data.error) {
                            this.loginErrorRes = response.data.error;
                            this.$errorToast(response?.data?.error);
                        } else {
                            this.$successToast(response.data.success);
							let userData = response?.data;
							this.$cookies.set(AUTH_TOKEN, userData?.user?.token);
                            this.$store.dispatch('setClickBetValue', [...this.initValues]);
							this.$store.dispatch('setToken', `Bearer ${userData?.user?.token}`);
							window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
							//for add on all APIs
							axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
							setHeaders();
							this.setUserDataToStore(userData);
                            this.setUserIdsToStore(userData?.user?.userid)
                            this.refreshData();
                            if(this.$route.name == 'Login') {
                                this.loginErrorRes = null;
                                this.$router.go();
                                return;
                            }else{
                                setTimeout(()=>{location.reload();},200)
                                this.$helper.closeModal('loginModal')
                            }
                        }
                    }
                }
            }).catch(error => {
                console.log(error);
                
                this.$store.dispatch('setGlobalLoader', false);
                if (type == 'demo') {
                    this.demoLoading = false;
                } else {
                    this.loading = false;
                }
                if (error) {
                    if(this.$route.name != 'Login') {
                        this.$errorToast(error[0]);
                    }
                    this.loginErrorRes = error[0];
                }
            });
        },
        getId() {
            if (this.$siteSettings.data.business_type == 2) {
                return this.form.type == 1 ? this.form.mobileNo : this.form.userId;
            } else {
                return this.form.userId;
            }
        },
        async signInwithOtp() {
            this.$store.dispatch('setGlobalLoader', true);
            let id = this.getId();
            let data = {
                mobile: id.toString(),
                countrycode: this.form.code,
                otp: this.form.otp
            };
            await this.$apiCall('post', 'LOGIN_WITH_OTP', data).then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response.data.error) {
                            this.loginErrorRes = response.data.error;
                            this.$errorToast(response?.data?.error);
                        } else {
                            this.$successToast(response.data.success);
							let userData = response?.data;
							this.$cookies.set(AUTH_TOKEN, userData?.user?.token);
                            this.$store.dispatch('setClickBetValue', [...this.initValues]);
							this.$store.dispatch('setToken', `Bearer ${userData?.user?.token}`);
							window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
							//for add on all APIs
							axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
							setHeaders();
							this.setUserDataToStore(userData);
                            this.setUserIdsToStore(userData?.user?.userid)
							this.refreshData();
                            if(this.$route.name == 'Login') {
                                this.loginErrorRes = null;
                                this.$router.go();
                                return;
                            }else{
                                setTimeout(()=>{location.reload();},200)
                                this.$helper.closeModal('loginModal')
                            }
                        }
                        this.$store.dispatch('setGlobalLoader', false);
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.loginErrorRes = error[0];
                    this.$errorToast(error[0]);
                }
            });
        },
        signUpCall() {
            if (!this.isOtpApiCalled) {
                this.$errorToast('Call for OTP.');
                return
            } else {
                var regex = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/;
                let o = this.getOtp();
                if (!this.form.mobileNo) {
                    this.$errorToast(this.$t('please-enter-mobile-number', 'Please enter mobile number.'));
                } else if (o.toString().length != 6 || this.form.password == '' || this.form.confirmPassword == '') {
                    this.$errorToast(this.$t('please-fill-all-fields', 'Please fill all fields.'));
                }else if(!regex.test(this.form.password)){
                    this.$errorToast( this.$t('forget-valid-msg', 'Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric.'));
                } 
                else if (this.form.password != this.form.confirmPassword) {
                    this.$errorToast(this.$t('password-mismatch-msg', 'Password and confirm password not same.'));
                } else {
                    this.signUpServiceCall();
                }
            }
        },
        async signUpServiceCall() {
            this.$store.dispatch('setGlobalLoader', true);
            let isDownLine = this.getQueryParam("downline", window.location.href);
            let af_code = this.getQueryParam("af_code", window.location.href);
            let refer_code = af_code ? "" : this.getQueryParam("refer_code", window.location.href);
            let data = {
                "userid": this.form.userName,
                "mobile": this.form.mobileNo,
                "password": this.form.password,
                "otp": this.getOtp(),
                "isDownLine": isDownLine ? isDownLine : false,
                "refer_code": refer_code ? refer_code : this.form.referCode,
                "country_code": this.form.code.includes('+') ? this.form?.code?.replace('+','') : this.form.code,
                "affiliate_code": af_code
            };
            await this.$apiCall('post', 'REGISTER', data).then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response?.data?.error) {
                            this.signUpErrorRes = response?.data?.error;
                            this.$errorToast(response?.data?.error);
                        } else {
                            this.$successToast(response?.data?.success);
                            if(this.$route.name == 'SignUp') {
                                setTimeout(() => {
                                    this.$router.push({name: 'Login'});
                                    this.$store.dispatch('setGlobalLoader', false);
                                }, 1000)
                                return;
                            }
                            this.$helper.closeModal('#register1')
                            this.$helper.openModal('#loginModal');                           
                        }
                    }
                }
                this.$store.dispatch('setGlobalLoader', false);
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                this.signUpErrorRes = error[0];
                if (error)
                    this.$errorToast(error[0]);
            });
        },
        setUserDataToStore(userData) {
            let user = {
                balance: userData?.user?.balance,
                currency: userData?.user?.currency,
                currency_slug: userData?.user?.currency_slug,
                last_login_at: userData?.user?.last_login_at,
                name: userData?.user?.name,
                rid: userData?.user?.rid,
                userid: userData?.user?.userid,
                exposure: userData?.user?.expl,
                available_credits: userData?.user?.available_credits,
                id: userData?.user?.id,
                exp: userData?.user?.exp,
                notificationSubscribed: null,
                notificationUnsubscribed: null,
            }
            this.$store.dispatch('setUser', userData?.user);
            this.$store.dispatch('setChips', userData?.user?.chips);
            this.$store.dispatch('setEventManage', userData?.event_manage);
        },
        getQueryParam(paramName, url) {
            if (!url) url = location.href;
            paramName = paramName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + paramName + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : results[1];
        },
        forgetPasswordCall() {
            if (!this.isOtpApiCalled)
                return
            let o = this.getOtp();           
            this.passwordValidation = false;
            var regex = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/;
            if (this.form.mobileNo == "") {
                this.showErrorMobile = true;
            }else if(!regex.test(this.form.password)){
                this.passwordValidation = true;
            } 
            else if (o.toString().length != 6 || this.form.password == '' || this.form.confirmPassword == '') {
                this.showValidationError = true;
            }
            else if (this.form.password != this.form.confirmPassword) {
                this.passwordValidation = true;
            }
            else {
                this.forgotServiceCall();
            }
        },
        async forgotServiceCall() {
            this.$store.dispatch('setGlobalLoader', true);
            let data = {
                "mobile": this.form.mobileNo,
                "countrycode": this.form.code.includes('+') ? this.form?.code?.replace('+','') : this.form.code,
                "password": this.form.password,
                "confirm_password": this.form.confirmPassword,
                "otp": this.getOtp(),
            };
            await this.$apiCall('post','FORGOT_PASSWORD', data).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response.data.error) {
                            this.forgotPassErrorRes = response.data.error;
                            this.$errorToast(response?.data?.error);
                        }
                        else {
                            this.refreshData();
                            if(this.$route.name == 'LandingPage') {
                                this.$router.go('/login');
                                return;
                            }
                            else{
                                if(this.$route.name == 'ForgotPassword') {
                                    this.$router.push({name: 'Login'});
                                    return;
                                }
                                this.$successToast(response.data.success);
                                this.$helper.closeModal('getnewpass')
                                this.$helper.openModal('#loginModal');    
                            }
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                this.forgotPassErrorRes = error;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        refreshData() {
            this.form = {
                code: this.$siteSettings.data && this.$siteSettings.data.cncode ? this.$siteSettings.data.cncode : "91",
                mobileNo: "",
                otp: '',
                userName: '',
                password: "",
                confirmPassword: "",
                captchaText: '',
                type: this.$siteSettings.data.business_type == 2 ? 1 : 2
            },
                this.isOtpApiCalled = false,
                this.resendOtp = false,
                this.resendOtpTimer = 0,
                this.timerRunning = false,
                this.minutes = 0,
                this.seconds = 0,
                this.otpSent = false,
                this.passwordFieldType = 'password',
                this.confPasswordFieldType = 'password',
                this.init = false
        },
        sendOtpCall(auth_type) {
            if (!this.form.mobileNo) {
                this.$errorToast(this.$t('please-enter-phone-number', 'Please Enter Phone Number.'));
                return false;
            } else if (this.form.mobileNo.toString().length != 10) {
                this.$errorToast(this.$t('number-must-10', 'Number Must be 10 digit.'));
                return false;
            }
            this.sendOtpServiceCall(auth_type);
        },
        async sendOtpServiceCall(auth_type) {
            let data = {
                type: auth_type,
                // type: auth_type == 'forgot' ? 'forgot-password' : 'registration',
                mobile: this.form.mobileNo, 
                countrycode: this.form.code.includes('+') ? this.form?.code?.replace('+','') : this.form.code
            }
            await this.$apiCall('post', 'SEND_OTP', data).then(response => {
                if (response) {
                    if (response.status == 200) {
                        this.isOtpApiCalled = true;
                        this.otpSent = true; // OTP sent successfully, disable phone number field
                        this.isDisabled = false;
                        // this.$successToast(response.data.data)
                        this.resendOtp = true;
                        this.timerRunning = true;
                        this.minutes = 5;
                        this.seconds = 0;
                        this.setResendTimer();
                        let sendResData = { status: response.status, message: response.data.data };
                        this.otpSuccessRes = sendResData;
                    }
                }
            }).catch(error => {
                this.otpErrorRes = error;
                if (error)
                    this.$errorToast(error[0])
            });
        },
        getOtp() {
            if (this.form.otp) {
                return +this.form.otp;
            }
            return '';
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'password'){
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
            } else {
                this.confPasswordFieldType = this.confPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        setResendTimer() {

            const countdown = () => {
                if (this.minutes === 0 && this.seconds === 0) {
                    this.timerRunning = false;
                    // Timer has expired, you can perform any action here
                } else {
                    if (this.seconds === 0) {
                        this.minutes--;
                        this.seconds = 59;
                    } else {
                        this.seconds--;
                    }
                    setTimeout(countdown, 1000);
                }
            };

            setTimeout(countdown, 1000);
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
        openByClosingModal(closingModal, openingModal){
            this.$helper.closeModal(closingModal);
            this.$helper.openModal(openingModal);
        }
    }
}